  import * as React from 'react';

  import Dialog from '@mui/material/Dialog';
  import DialogTitle from '@mui/material/DialogTitle';
  import DialogContent from '@mui/material/DialogContent';
  import StatusContext from '../../../contexts/StatusContext'
  import AITestContext from '../../../contexts/AITestContext'
  import IconButton from '@mui/material/IconButton';
  import CloseIcon from '@mui/icons-material/Close';
  import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';
  import CopyMoreAnswer from './CopyMoreAnswer';
  import { ArrowForwardIcon } from '../customicons/ArrowForwardIcon';
  import { ButtonAIProvider } from '../buttonaiprovider/ButtonAIProvider';
  

  import "./aitest.css"


  export const DialogMoreAnswer = () => {

    const {
      isMe,
      changeLanguage,
      getAIProvider,
      getAIName,
  } = React.useContext(StatusContext);

 
  const {
    moreanswer, 
    setShowMoreAnswerDialog,
    showmoreanswerdialog,
    setMoreAnswerStatus,
    moreanswerstatus,
    questionsMoreAnswer,
    showquestions,

  } = React.useContext(AITestContext);

   
  const handleClose = (event, reason) => {
  
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      // Handle the backdrop click event here
      return
    }

    setMoreAnswerStatus('')
    setShowMoreAnswerDialog(false);
  };

  
  const handleQuestion1 = () => {

    localStorage.setItem('CopilotQuestion',questionsMoreAnswer.question1)
    window.open('/copilot', '_blank'); // Opens in a new tab

  }

  const handleQuestion2 = () => {
    localStorage.setItem('CopilotQuestion',questionsMoreAnswer.question2)
  
    window.open('/copilot', '_blank'); // Opens in a new tab

  }

  const handleQuestion3 = () => {
    localStorage.setItem('CopilotQuestion',questionsMoreAnswer.question3)

    window.open('/copilot', '_blank'); // Opens in a new tab

  }

    return (
    
      <React.Fragment>
    
          <Dialog
            open={showmoreanswerdialog}
          
            PaperProps={{
              component: 'form',
              onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const email = formJson.email;
                console.log(email);
                
              },
            }}
          >

          <DialogTitle style = {{fontSize:'14px'}}>
            {changeLanguage('aitest', 'moreanswertitle')}
          </DialogTitle>


          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
          <CloseIcon />
        </IconButton>

          <DialogContent dividers>
          
                <div>
                  <div className="flex-container">
                  <CopyMoreAnswer text={moreanswer}/>
                   {isMe() && <ButtonAIProvider provider={getAIProvider()} model={getAIName()}/>}
                  </div>
                 
                  <MarkdownResponseDisplay text={moreanswer} />

                  <hr className="separator"></hr>
                
                {
                  showquestions &&

                  <>
                  <div className="flex-container-top" >
                    <div style={{marginRight: '10px'}}>
                      <ArrowForwardIcon onClick={handleQuestion1}/>
                    </div>
                    <MarkdownResponseDisplay text={questionsMoreAnswer.question1} paragraphcolor={'maroon'}/>
                  </div>

                  <div className="flex-container-top" >
                    <div style={{marginRight: '10px'}}>
                      <ArrowForwardIcon onClick={handleQuestion2}/>
                    </div>
                    <MarkdownResponseDisplay text={questionsMoreAnswer.question2} paragraphcolor={'maroon'}/>
                  </div>

                  <div className="flex-container-top" >
                    <div style={{marginRight: '10px'}}>
                      <ArrowForwardIcon onClick={handleQuestion3}/>
                    </div>
                    <MarkdownResponseDisplay text={questionsMoreAnswer.question3} paragraphcolor={'maroon'}/>
                  </div>
                  </>
                }
                </div>
  
                <br></br>
            
              
                {
                  (moreanswerstatus !== "") && <label>{moreanswerstatus}</label>
                }
            
      
            
          </DialogContent>
        </Dialog>
      </React.Fragment>
      
    );
    
  }